import "./home-page.css";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";

import MarketingFooter from "./components/MarketingFooter";
export default function MenuAI() {



  return (
    <div className="home-pro">

<SEO
 title="Menu Digitale con Intelligenza Artificiale per Ristoranti e Pizzerie | QrMenu Italia"
  description="QrMenu Italia integra intelligenza artificiale nel menu digitale per aiutare ristoranti, pizzerie e locali a valorizzare i piatti, guidare il cliente nella scelta, migliorare traduzioni, immagini e supportare anche la sala."
  canonical="https://qrmenu-italia.it/menu-ai"
  image="https://qrmenu-italia.it/og-ai.jpg"
  keywords="intelligenza artificiale ristoranti, menu digitale con intelligenza artificiale, ai per ristoranti, menu intelligente, menu digitale ai, assistente virtuale ristorante, qrmenu"
/>
<MarketingNavbar />

      {/* HERO */}
      <section className="hp-hero">

        <div className="hp-hero-noise"></div>
        <div className="hp-hero-glow"></div>

        <div className="hp-hero-inner">

<div className="hp-hero-eyebrow">
  <span className="hp-dot"></span>
  INTELLIGENZA ARTIFICIALE PER IL TUO LOCALE
</div>

<h1 className="hp-hero-h1">
  Un menu che aiuta il cliente a scegliere
  <span className="hp-hero-accent">
     e valorizza davvero i tuoi piatti.
  </span>
</h1>

<p className="hp-hero-sub">
 QrMenu usa l’intelligenza artificiale per guidare il cliente nella scelta,
suggerire piatti, abbinamenti e prodotti aggiuntivi, supportare la sala durante il servizio
e aiutare il gestore nella creazione di contenuti e traduzioni.

</p>

<div className="hp-hero-pills">
  <span className="hp-pill">✦ Suggerimenti intelligenti</span>
  <span className="hp-pill">✦ Regole decise dal gestore</span>
  <span className="hp-pill">✦ Traduzioni più curate</span>
  <span className="hp-pill">✦ Immagini dei piatti</span>
  <span className="hp-pill">✦ Alert intelligenti per la sala</span>
</div>

<div className="hp-hero-actions">
  <a href="/demo" className="hp-btn-demo">
    Prova Gratis 7 Giorni
  </a>

  <a href="/contatti" className="hp-btn-ghost">
    Richiedi informazioni
  </a>
</div>

        </div>

        <div className="hp-hero-mockup">

          <div className="hp-phone">

            <div className="hp-phone-notch"></div>

            <div className="hp-phone-screen">

              <div className="hp-screen-header">

                <div className="hp-screen-tag">
  MENU INTELLIGENTE
</div>

              </div>

              <div className="hp-screen-ai">

                <span className="hp-screen-ai-dot"></span>

                Ti consigliamo un vino rosso
                perfetto con questa carne

              </div>

              <div className="hp-screen-item">

                <div className="hp-screen-item-img"></div>

                <div className="hp-screen-item-info">

                  <div className="hp-screen-item-name">
                    Tagliata premium
                  </div>

                  <div className="hp-screen-item-price">
                    €24
                  </div>

                </div>

              </div>

              <div className="hp-screen-ai">

                <span className="hp-screen-ai-dot"></span>

                Il locale consiglia questo piatto
                come specialità della casa

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* SEO CONTENT */}
      <section className="hp-problem">

<div className="hp-problem-inner">
  <div className="hp-section-tag">
    Non solo tecnologia
  </div>

  <h2 className="hp-section-h2">
    L’intelligenza artificiale diventa utile solo se aiuta davvero il locale
  </h2>

  <p className="hp-seo-text">
    In molti locali ci sono piatti validi che passano inosservati, clienti
    indecisi davanti al menu e prodotti che meriterebbero di essere raccontati meglio.
  </p>

  <p className="hp-seo-text">
    QrMenu usa l’intelligenza artificiale per aiutare il cliente a orientarsi,
    suggerire abbinamenti, valorizzare specialità e rendere l’esperienza più semplice.
  </p>

  <p className="hp-seo-text">
    Il gestore resta sempre al centro: può decidere cosa far valorizzare,
    quale tono usare e quali funzioni attivare. Nulla è obbligatorio.
  </p>

<p className="hp-seo-text">
  In pratica, l’intelligenza artificiale non serve solo a migliorare il menu:
può aiutare il cliente a scegliere, valorizzare i prodotti che vuoi proporre
e supportare il servizio in sala attraverso alert che segnalano al personale
quando una situazione potrebbe richiedere attenzione.

</p>
</div>

        {/* FEATURES */}
        <section className="hp-features">

<div className="hp-section-tag">
  Intelligenza artificiale per il locale
</div>

 <h2 className="hp-section-h2">
  Dove può aiutarti davvero l’intelligenza artificiale di QrMenu
</h2>

          <div className="hp-features-grid">

 <div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Il cliente sceglie con più facilità
  </h3>

  <p className="hp-feat-desc">
    L’intelligenza artificiale può aiutare il cliente indeciso a trovare
    piatti adatti ai suoi gusti, al momento o alla situazione.
  </p>
</div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    I piatti migliori non restano nascosti
  </h3>

  <p className="hp-feat-desc">
    Il locale può valorizzare specialità, abbinamenti, prodotti stagionali
    o piatti che vuole far conoscere meglio.
  </p>
</div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Il locale resta sempre al centro
  </h3>

  <p className="hp-feat-desc">
    L’intelligenza artificiale può seguire le indicazioni del gestore,
    valorizzare i piatti che vuoi spingere e parlare con il tono più adatto al tuo locale.
  </p>
</div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Menu più chiaro per clienti stranieri
  </h3>

  <p className="hp-feat-desc">
    Le traduzioni aiutano a rendere il menu più comprensibile anche per chi
    parla un’altra lingua, senza perdere il valore dei piatti.
  </p>
</div>


<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Immagini e contenuti più curati
  </h3>

  <p className="hp-feat-desc">
    QrMenu può aiutare anche nella presentazione dei piatti, con immagini
    e contenuti pensati per rendere il menu più moderno e appetibile.
  </p>
</div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Il personale sa dove serve attenzione
  </h3>

  <p className="hp-feat-desc">
    Gli alert aiutano a mettere in evidenza i tavoli che potrebbero aver bisogno
    del personale, permettendo alla sala di organizzare meglio gli interventi
    senza sostituire il lavoro dei camerieri.
  </p>
</div>

          </div>

        </section>

      </section>
      <MarketingFooter />
    </div>
  );
}